export default "__VITE_ASSET__37IVPHob__"